import { FetchOrganizationUserAnalyticsEndAction } from "../actions/FetchOrganizationUserAnalytics";
import { OrgState } from "../state";

export function fetchOrganizationUserAnalytics(state: OrgState, action: FetchOrganizationUserAnalyticsEndAction) {
    const { error, organizationId, result } = action.payload;
    const newState: Partial<OrgState> = { error };
    newState.userAnalytics = { ...state.userAnalytics };
    newState.userAnalytics[organizationId] = result;

    return { ...state, ...newState };
}
